var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_547_9843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 65C56.5685 65 70 51.5685 70 35C70 18.4315 56.5685 5 40 5C23.4315 5 10 18.4315 10 35C10 51.5685 23.4315 65 40 65Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8826 36.1067C30.8363 35.7207 30.8125 35.3373 30.8125 35C30.8125 29.9655 34.9655 25.8125 40 25.8125C42.3483 25.8125 44.5469 26.7593 46.1641 28.2359L45.3531 29.061C45.1703 29.2437 45.1 29.5109 45.1703 29.7641C45.2548 30.0031 45.4516 30.186 45.7047 30.2422C45.8462 30.2706 50.496 31.7689 50.1999 31.7094C50.5765 31.8348 51.1335 31.4331 51.0297 30.8798C51.0012 30.738 49.9717 25.5728 50.0312 25.8687C49.975 25.6157 49.7921 25.4047 49.5391 25.3344C49.3001 25.2641 49.0328 25.3344 48.85 25.5172L48.161 26.1921C46.0375 24.2094 43.1218 23 40 23C33.4047 23 28 28.4047 28 35V35.028C28 35.4244 28.0181 35.7308 28.0392 35.9651C28.0672 36.2757 28.2961 36.53 28.6019 36.5914L30.0464 36.8801C30.5166 36.9742 30.9394 36.58 30.8826 36.1067Z",
    fill: "#2297FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4025 33.4073L49.9538 33.1121C49.483 33.0162 49.0573 33.4108 49.1151 33.8863C49.1653 34.2966 49.1876 34.6956 49.1876 34.9998C49.1876 40.0341 45.0346 44.1873 40.0001 44.1873C37.6518 44.1873 35.4533 43.2404 33.8361 41.7498L34.6471 40.9388C34.8298 40.7561 34.9001 40.4889 34.8298 40.2357C34.7454 39.9965 34.5485 39.8138 34.2955 39.7576C34.154 39.729 29.5042 38.2309 29.8003 38.2904C29.5611 38.2482 29.322 38.3186 29.1674 38.4872C28.9986 38.6419 28.9283 38.895 28.9704 39.12C28.999 39.2616 30.0286 44.3799 29.9691 44.084C30.0251 44.3372 30.208 44.5482 30.4611 44.6183C30.7546 44.6919 30.9996 44.6029 31.1501 44.4356L31.8252 43.7606C33.9485 45.7435 36.8643 46.9998 40.0001 46.9998C46.5954 46.9998 52.0001 41.595 52.0001 34.9998V34.9575C52.0001 34.6458 51.9888 34.3399 51.9628 34.0357C51.9361 33.725 51.7081 33.4697 51.4025 33.4073Z",
    fill: "#2297FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_547_9843",
    x: 0,
    y: 0,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_9843"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_547_9843",
    result: "effect2_dropShadow_547_9843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_547_9843",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefreshIcon);
export default __webpack_public_path__ + "static/media/ic_refresh_icon.77cc323a182d5523ded8626679595a20.svg";
export { ForwardRef as ReactComponent };